import { createFileRoute } from "@tanstack/react-router";
import AcceleratedTmsFmriTargeting from "@/pages/AcceleratedTmsFmriTargeting";
export const Route = createFileRoute("/accelerated-tms-fmri-targeting")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "How Brain Mapping Works in SAINT® TMS | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "fMRI-guided TMS targeting personalizes treatment to your brain. Learn how SAINT TMS uses fMRI in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "How Brain Mapping Works in SAINT® TMS | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "fMRI-guided TMS targeting personalizes treatment to your brain. Learn how SAINT TMS uses fMRI in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/accelerated-tms-fmri-targeting",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/accelerated-tms-fmri-targeting",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AcceleratedTmsFmriTargeting />;
}
